(function () {
	// Function to get all the next siblings of an element
	const nextSiblings = (currentElement) => {
		let next_siblings = [];
		let sibling = currentElement.nextElementSibling;

		while (sibling) {
			next_siblings.push(sibling);
			sibling = sibling.nextElementSibling;
		}

		return next_siblings;
	}

	const footer = () => {
		 const caculateNewsletterMargin = () => {
			//debugger;
			const footerNewsletter = document.querySelector(".footer--newsletter__form--center");

		// Only proceed if the newsletter form exists
		if (footerNewsletter) {
			let footerParent = footerNewsletter.parentNode;
			let footerStyles = window.getComputedStyle(footerParent);

			// Calculate the total height of next siblings
			let marginTop = nextSiblings(footerNewsletter).reduce((totalHeight, sibling) => {
				const siblingHeight = sibling.offsetHeight || 0; // Handle hidden elements
				return totalHeight + siblingHeight;
			}, 0) - parseInt(footerStyles.getPropertyValue('padding-top'), 10);
			
			let enoughSpace = (window.outerHeight - marginTop * 2 - footerNewsletter.offsetHeight) > 0;

			marginTop = marginTop > 0 && enoughSpace ? marginTop : 0;

			// Apply the calculated margin to the newsletter
			footerNewsletter.style.marginTop = `${marginTop}px`;
		 }
		}

		caculateNewsletterMargin();
		window.addEventListener("resize", () => setTimeout(() =>caculateNewsletterMargin(), 500));
	}

	// Reapply the footer logic when the section is reloaded
	document.addEventListener('shopify:section:load', footer);
	footer();
})();


//(function () {
//	const nextSiblings = (currentElement) => {
//		let next_siblings = [];
//		let sibling = currentElement.nextElementSibling;

//		while (sibling) {
//			next_siblings.push(sibling);
//			sibling = sibling.nextElementSibling;
//		}

//		return next_siblings;
//	}

//	const footer = () => {
//		const caculateNewsletterMargin = () => {
//			const footerNewsletter = document.querySelector(".footer--newsletter__form--center");

//			if (footerNewsletter) {
//				let footerParent = footerNewsletter.parentNode;
//				let footerStyles = window.getComputedStyle(footerParent);

//				// Calculate total height of next siblings only if needed
//				let marginTop = nextSiblings(footerNewsletter).reduce((totalHeight, sibling) => {
//					const siblingHeight = sibling.offsetHeight || 0;
//					return totalHeight + siblingHeight;
//				}, 0) - parseInt(footerStyles.getPropertyValue('padding-top'), 10);

//				let enoughSpace = (window.innerHeight - marginTop * 2 - footerNewsletter.offsetHeight) > 0;

//				// Apply margin only if necessary
//				footerNewsletter.style.marginTop = enoughSpace && marginTop > 0 ? `${marginTop}px` : '0';
//			}
//		}

//		// Re-run calculations on window resize or Swiper updates
//		caculateNewsletterMargin();
//		window.addEventListener("resize", () => setTimeout(caculateNewsletterMargin, 500));

//		document.addEventListener('swiper-init', () => setTimeout(caculateNewsletterMargin, 500));
//	}

//	document.addEventListener('shopify:section:load', footer);
//	footer();

//	// Trigger calculation after Swiper init
//	if (typeof Swiper !== 'undefined') {
//		const swiperInstance = new Swiper('.swiper-container', {
//			on: {
//				init: function() {
//					const event = new Event('swiper-init');
//					document.dispatchEvent(event);
//				},
//				resize: function() {
//					const event = new Event('swiper-init');
//					document.dispatchEvent(event);
//				}
//			}
//		});
//	}
//})();